
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import {Component} from 'react';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import PropTypes from 'prop-types';
import {SwarmDataMixin} from "../../../../dev/mixins/swarmDataMixin";
import Helpers from "../../../helpers/helperFunctions";
import {SetBalance, LoyalCard} from "../../../actions/terminal";

class Balance extends Component {

    constructor (props) {
        super(props);
        this.showBalance = this.showBalance.bind(this);
        this.deleteCard = this.deleteCard.bind(this);
        this.openCardWrapper = this.openCardWrapper.bind(this);
        this.state = {
            showBalance: true,
            balance: JSON.parse(sessionStorage.getItem("balance"))?.session_balance,
            loyalCard: false
        };
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        let terminalBalance = nextProps.terminalBalance;
        if (terminalBalance !== undefined && terminalBalance !== null) {
            this.setState((prevState) => {
                return {balance: terminalBalance || prevState.balance
                };
            });
            if (terminalBalance !== this.props.terminalBalance) {
                this.props.dispatch(SetBalance(terminalBalance));
                if (terminalBalance === 0) {
                    this.props.dispatch(LoyalCard(null));
                    this.setState({
                        loyalCard: false
                    });
                }
            }
        }
    }
    openCardWrapper () {
        if (!this.state.loyalCard && this.props.loyalCard) {
            this.setState({
                loyalCard: true
            });
        } else {
            this.setState({
                loyalCard: false
            });
        }
    }
    deleteCard () {
        this.props.dispatch(LoyalCard(null));
        this.setState({
            loyalCard: false
        });
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    showBalance () {
        return () => {
            this.setState({
                showBalance: !this.state.showBalance
            });
        };
    }
}

const getSwarmSubscriptionRequest = (tid) => {
    let req = {
        "source": "terminals",
        "what": {"terminals": []},
        "where": {"tid": tid}
    };
    return req;
};

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.user.profile,
            state => state.terminal.authData,
            state => state.swarmData.data.terminal_balance &&
                Helpers.firstElement(state.swarmData.data.terminal_balance.terminals) &&
                Helpers.firstElement(state.swarmData.data.terminal_balance.terminals).balance,
            state => state.terminal.loyalCard && state.terminal.loyalCard.result
        ],
        (profile, authData, terminalBalance, loyalCard) => {
            return {
                profile,
                authData,
                terminalBalance,
                loyalCard
            };
        }
    );
};
export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: Balance,
        ComponentWillMount: function () {
            this.swarmSubscriptionRequest = getSwarmSubscriptionRequest(this.props.authData.tid);
            this.swarmDataKey = 'terminal_balance';
            this.keepDataAfterUnsubscribe = true;
        }
    }
));

Balance.propTypes = {
    terminalBalance: PropTypes.number,
    profile: PropTypes.object,
    authData: PropTypes.object,
    loyalCard: PropTypes.string
};